var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Regular/Light/Edit Square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34624291",
    d: "M12 4H7C5.34315 4 4 5.34315 4 7V17C4 18.6569 5.34315 20 7 20H17C18.6569 20 20 18.6569 20 17V12",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M15.5551 5.82313L18.1772 8.44509M9 15L12.18 14.3593C12.3488 14.3253 12.5038 14.2421 12.6255 14.1203L19.7442 6.99805C20.0855 6.65657 20.0852 6.10305 19.7437 5.76186L18.2357 4.25564C17.8942 3.91459 17.341 3.91482 16.9998 4.25615L9.8804 11.3792C9.7589 11.5008 9.67594 11.6554 9.6419 11.8239L9 15Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.579c51ce142f5db02f9fd0f9741b3e38.svg";
export { ForwardRef as ReactComponent };